import React, { useEffect, useState } from 'react';
import { Heart, Zap, Gift, Mic, ChevronRight } from 'lucide-react';
export const ProfilePanel = () => {
  const [avatarSrc, setAvatarSrc] = useState('https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png');
  // Load avatar from settings if available
  useEffect(() => {
    try {
      const savedSettings = localStorage.getItem('userSettings');
      if (savedSettings) {
        const settings = JSON.parse(savedSettings);
        if (settings.avatar && settings.avatar.selectedAvatar) {
          setAvatarSrc(settings.avatar.selectedAvatar);
        }
      }
    } catch (error) {
      console.error('Failed to load avatar from settings:', error);
    }
  }, []);
  return <section className="w-full rounded-md bg-white dark:bg-gray-900 border border-of-gray dark:border-gray-800 shadow-sm overflow-hidden max-md:mx-2" data-id="element-15968">
      <div className="p-4 flex gap-4 items-center" data-id="element-15969">
        <div className="relative" data-id="element-15970">
          <div className="w-20 h-20 rounded-full border-2 border-of-blue dark:border-faded-purple p-1" data-id="element-15971">
            <img src={avatarSrc} alt="AI Companion" className="w-full h-full object-cover rounded-full" data-id="element-15972" />
          </div>
          <div className="absolute -bottom-1 -right-1 bg-green-500 w-4 h-4 rounded-full border-2 border-white dark:border-gray-900" data-id="element-15973"></div>
        </div>
        <div className="flex-1" data-id="element-15974">
          <div className="flex items-center gap-2" data-id="element-15975">
            <h2 className="text-xl font-medium text-of-text-primary dark:text-white" data-id="element-15976">
              GoldenShowerTina
            </h2>
            <div className="text-xs px-2 py-0.5 rounded-full bg-of-gray dark:bg-gray-800 text-of-text-secondary dark:text-gray-400" data-id="element-15977">
              online
            </div>
          </div>
          <p className="text-sm text-of-text-secondary dark:text-gray-400" data-id="element-15978">
            "Your sinful Angel, always ready to play..."
          </p>
          <div className="mt-2 space-y-2" data-id="element-15979">
            <div className="flex items-center gap-2" data-id="element-15980">
              <Heart size={14} className="text-pink-500 dark:text-pink-400" data-id="element-15981" />
              <div className="flex-1 h-2 bg-of-gray dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-15982">
                <div className="h-full bg-pink-500 dark:bg-pink-400 w-3/5 rounded-full" data-id="element-15983"></div>
              </div>
              <span className="text-xs font-medium dark:text-gray-300" data-id="element-15984">
                Lvl 3
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-15985">
              <Zap size={14} className="text-purple-500 dark:text-purple-400" data-id="element-15986" />
              <div className="flex-1 h-2 bg-of-gray dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-15987">
                <div className="h-full bg-purple-500 dark:bg-purple-400 w-2/5 rounded-full" data-id="element-15988"></div>
              </div>
              <span className="text-xs font-medium dark:text-gray-300" data-id="element-15989">
                40%
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-5 border-t border-of-gray dark:border-gray-800" data-id="element-15990">
        <button className="flex flex-col items-center justify-center py-3 hover:bg-of-gray-light dark:hover:bg-gray-800 transition" data-id="element-15991">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-of-gray dark:bg-gray-800" data-id="element-15992">
            <span data-id="element-15993">💬</span>
          </div>
          <span className="text-xs mt-1 dark:text-gray-300" data-id="element-15994">Chat</span>
        </button>
        <button className="flex flex-col items-center justify-center py-3 hover:bg-of-gray-light dark:hover:bg-gray-800 transition" data-id="element-15995">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-of-gray dark:bg-gray-800" data-id="element-15996">
            <Gift size={14} className="text-of-text-primary dark:text-gray-300" data-id="element-15997" />
          </div>
          <span className="text-xs mt-1 dark:text-gray-300" data-id="element-15998">Gift</span>
        </button>
        <button className="flex flex-col items-center justify-center py-3 hover:bg-of-gray-light dark:hover:bg-gray-800 transition" data-id="element-15999">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-of-gray dark:bg-gray-800" data-id="element-16000">
            <Zap size={14} className="text-of-text-primary dark:text-gray-300" data-id="element-16001" />
          </div>
          <span className="text-xs mt-1 dark:text-gray-300" data-id="element-16002">Buzz</span>
        </button>
        <button className="flex flex-col items-center justify-center py-3 hover:bg-of-gray-light dark:hover:bg-gray-800 transition" data-id="element-16003">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-of-gray dark:bg-gray-800" data-id="element-16004">
            <span data-id="element-16005">👗</span>
          </div>
          <span className="text-xs mt-1 dark:text-gray-300" data-id="element-16006">Dress</span>
        </button>
        <button className="flex flex-col items-center justify-center py-3 hover:bg-of-gray-light dark:hover:bg-gray-800 transition" data-id="element-16007">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-of-gray dark:bg-gray-800" data-id="element-16008">
            <Mic size={14} className="text-of-text-primary dark:text-gray-300" data-id="element-16009" />
          </div>
          <span className="text-xs mt-1 dark:text-gray-300" data-id="element-16010">Voice</span>
        </button>
      </div>
    </section>;
};